var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideKeypad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8651 13.3387C14.8651 14.1744 14.2154 14.8241 13.3797 14.8241H7.02642C6.19073 14.8241 5.54102 14.1744 5.54102 13.3387V6.9854C5.54102 6.14972 6.19073 5.5 7.02642 5.5H13.3797C14.2154 5.5 14.8651 6.14972 14.8651 6.9854V13.3387Z",
    fill: "white",
    stroke: "#121212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 29.8242,
    width: 22,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76807,
    y: 17.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7681,
    y: 17.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.865,
    y: 5.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.865,
    y: 5.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7681,
    y: 17.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.12964,
    y: 2,
    width: 53.5433,
    height: 3.01181,
    transform: "rotate(45 2.12964 2)",
    fill: "#121212"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.12964,
    width: 53.5433,
    height: 3.01181,
    transform: "rotate(45 4.12964 0)",
    fill: "#FFC741"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideKeypad);
export default __webpack_public_path__ + "static/media/hide_keypad.445fabd6f7d020f635375563da91991b.svg";
export { ForwardRef as ReactComponent };